export const PhoneNumberConstants = {
  //"default": "+448000554548",
    "default": "+18554531966",
  // "default_SPH": "+18335063463",
  // "default_local_NO":"+18554531966"
};
